import { render, staticRenderFns } from "./FooterVersion.vue?vue&type=template&id=0c774795&scoped=true"
import script from "./FooterVersion.vue?vue&type=script&lang=js"
export * from "./FooterVersion.vue?vue&type=script&lang=js"
import style0 from "./FooterVersion.vue?vue&type=style&index=0&id=0c774795&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c774795",
  null
  
)

export default component.exports